(function () {
  'use strict';
  angular.module('ringbaPortal').filter('notInArray', notInArray);

  function notInArray(
    $filter
  ) {
    'ngInject';

    return function (list, arrayFilter, element) {
      return $filter('filter')(list, function (listItem) {
        if (arrayFilter && element) {
          for (let i = 0; i < arrayFilter.length; i++) {
            if (arrayFilter[i][element] === listItem[element]) {
              return false;
            }
          }
        } else if (arrayFilter && !element) {
          return arrayFilter.indexOf(listItem) === -1;
        }
        return true;
      });
    };
  }
})();
